/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreditCardProduct,
  HTTPUnauthorizedError,
  HTTPValidationError,
  LoyaltyProgram,
  LoyaltyRedemptionValueResponse,
} from '../models/index';
import {
    CreditCardProductFromJSON,
    CreditCardProductToJSON,
    HTTPUnauthorizedErrorFromJSON,
    HTTPUnauthorizedErrorToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    LoyaltyProgramFromJSON,
    LoyaltyProgramToJSON,
    LoyaltyRedemptionValueResponseFromJSON,
    LoyaltyRedemptionValueResponseToJSON,
} from '../models/index';

/**
 * 
 */
export class LoyaltyApi extends runtime.BaseAPI {

    /**
     * Get every credit card product Gondola recognizes from MX.
     */
    async creditCardProductsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CreditCardProduct>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/credit_card_products`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CreditCardProductFromJSON));
    }

    /**
     * Get every credit card product Gondola recognizes from MX.
     */
    async creditCardProductsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CreditCardProduct>> {
        const response = await this.creditCardProductsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all supported loyalty programs and their associated tiers.
     */
    async loyaltyProgramsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LoyaltyProgram>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/loyalty_programs`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LoyaltyProgramFromJSON));
    }

    /**
     * Get all supported loyalty programs and their associated tiers.
     */
    async loyaltyProgramsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LoyaltyProgram>> {
        const response = await this.loyaltyProgramsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get loyalty redemption values.
     */
    async loyaltyRedemptionValuesGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoyaltyRedemptionValueResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/loyalty_redemption_values`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoyaltyRedemptionValueResponseFromJSON(jsonValue));
    }

    /**
     * Get loyalty redemption values.
     */
    async loyaltyRedemptionValuesGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoyaltyRedemptionValueResponse> {
        const response = await this.loyaltyRedemptionValuesGetRaw(initOverrides);
        return await response.value();
    }

}
